import styled from "styled-components";
import ReactLoading from "react-loading";

interface IProps {
  color?: string;
}
export default function Loading({color='red'}:IProps) {
  return (
    <Container>
      <ReactLoading type="spin" color={color} height="10%" width="10%" />
    </Container>
  );
}

const Container = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.white};
`;
